module.exports = __webpack_public_path__ + "img/experience_enhancement_1.f94af167.png";